import React from 'react';
import HeroBackground from '../../../img/bkgd-profile.jpg';

const HeroSection = () => {
  return (
    <div
        className='banner' style={{ backgroundImage: `url(${HeroBackground})` }}>
    </div>
  );
};

export default HeroSection; 